<template>
  <v-app class="grey lighten-3" v-if="isLoggedIn">
    <v-layout>
      <v-flex xs12 sm12 md12>
        <v-toolbar class="project mt-2">
          <v-spacer></v-spacer>
          <v-toolbar-items class="hidden-sm-and-down">
            <v-btn flat class="white--text" @click="createProjectPage()"
              >create project</v-btn
            >
            <v-btn
              flat
              class="white--text"
              v-if="getProjectType() == 2"
              @click="locationPage()"
              >Location</v-btn
            >
            <v-btn flat class="white--text" @click="back()">Question</v-btn>
            <v-btn
              flat
              class="white--text"
              v-if="getProjectType() == 1"
              @click="budgetPage()"
              >Budget</v-btn
            >
            <v-btn
              flat
              class="white--text"
              v-if="getProjectType() == 2"
              @click="locationBasedBudgetPage()"
              >Location Budget</v-btn
            >
          </v-toolbar-items>
        </v-toolbar>
      </v-flex>
    </v-layout>
    <v-container>
      <v-layout>
        <div class="btn">
          <v-snackbar
            v-model="snackbar"
            :right="x === 'right'"
            :timeout="timeout"
            color="red"
            :top="y === 'top'"
          >
            {{ errorMsg }}
            <v-btn color="black" flat @click="snackbar = false"> Close </v-btn>
          </v-snackbar>
        </div>
         <v-flex xs12 sm12>
          <v-container grid-list-md>
            <v-card>
              <v-card-title class="project">
                <div class="white--text headline">
                  <span class="headline">Assign Agent Groups To Project</span>
                </div>
              </v-card-title>
              <v-card-text>
                <v-form ref="form" v-model="valid" lazy-validation>
                  <v-layout wrap v-if="indexData.agent_groups">
                    <v-flex xs12 sm6 md6>
                      <v-select
                        v-model="projectAgentData.agent_group"
                        :rules="agent_group"
                        :items="indexData.agent_groups"
                        :item-text="textItem"
                        item-value="id"
                        box
                        label="Select Agent Group"
                      ></v-select>
                    </v-flex>
                  </v-layout>
                  <v-layout wrap v-else>
                    Agent group not available. Please create a group now.
                  </v-layout>
                  <v-layout wrap v-if="projectAgentData.agent_group">
                    <v-radio-group
                      v-model="projectAgentData.agentTaskAssignmentMethod"
                    >
                      <v-radio label="Unlimited Response" value="1"></v-radio>
                      <v-radio label="Maximum Response" value="2"></v-radio>
                      <v-radio
                        label="Individual Response Per Agent"
                        value="3"
                      ></v-radio>
                    </v-radio-group>
                  </v-layout>
                  <v-layout wrap v-if="projectAgentData.agentTaskAssignmentMethod  == 2">
                    <v-flex xs12 sm6 md6>
                        <v-text-field
                          v-model="projectAgentData.numberOfMaximumResponsePerAgent"
                          box
                          label="Number Maximum Response Per Agent"                          
                        ></v-text-field>
                      
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <button class="button" flat @click="back">Back</button>
                <v-btn
                  :disabled="!hasAgentGroup"
                  class="button"
                  flat
                  @click="submit"
                  >Save & next</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-container>
        </v-flex>
      </v-layout>
    </v-container>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data: () => ({
    apiUrl: "project.agent-info",
    snackbar: false,
    y: "top",
    x: "right",
    timeout: 4000,
    projectAgentData: {
      agent_group: null,
      project_id: null,
    },
    defaultItem: {
      agent_group: null,
      project_id: null,
    },
    valid: true,
    agent_group: [(v) => !!v || "agent_group is required"],
  }),

  computed: {
    ...mapGetters([
      "isLoggedIn",
      "indexData",
      "error",
      "statusCode",
      "errorMsg",
    ]),
    dasher_category_check: function () {
      // console.log(this.dasher_category);
      return true;
    },

    hasAgentGroup(){
      if(this.projectAgentData.agent_group){
        return true;
      }else{
        return false;
      }
    },

    binding() {
      const binding = {};

      if (this.$vuetify.breakpoint.mdAndUp) binding.column = true;

      return binding;
    },
  },

  watch: {},

  created() {
    var project_id = JSON.parse(localStorage.getItem("project_id_modify"));
    this.$store.dispatch("indexData", [this.apiUrl, project_id]);
    // this.initialize();
    // this.editedData()
  },
  methods: {
    initialize() {
      //
    },

    textItem: function (event) {
      return event.name + " : " + event.code + "(" + event.numberOfAgent + ")";
    },
    close() {
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    getProjectType() {
      if (this.indexData.project_data) {
        if (this.indexData.project_data.project_type_id) {
          return this.indexData.project_data.project_type_id;
        }
      }
      return false;
    },
    createProjectPage() {
      var project_id = JSON.parse(localStorage.getItem("project_id_modify"));
      this.$store.dispatch("indexDataAndRout", [
        "project-info",
        project_id,
        "/create-project-edit",
      ]);
    },

    back() {
      var project_id = JSON.parse(localStorage.getItem("project_id_modify"));
      this.$store.dispatch("indexDataAndRout", [
        "question-json",
        project_id,
        "/edit-dynamic-question",
      ]);
    },

    submit() {
      // console.log(this.projectAgentData);
      if (this.$refs.form.validate()) {
        if (!this.projectAgentData.agent_group) {
          alert("please select at lest a group");
        } else {
          this.projectAgentData.project_id = JSON.parse(
            localStorage.getItem("project_id_modify")
          );
          this.$store.dispatch("storeOrUpdateProjectAgentAssignmentModify", [
            "assign.agent.group.to.project-modify",
            this.projectAgentData,
          ]);
        }
        this.snackbar = true;
        this.close();
      }
    },
  },
};
</script>

<style scoped>
.icon {
  background: #ff2e2e;
  color: aliceblue;
  cursor: pointer;
  border-radius: none;
  margin: 10px;
}
.delete {
  color: #3f51b5;
  cursor: pointer;
}
span {
  width: 30px;
  cursor: pointer;
}
.button {
  font-size: 16px;
  background: #ff2e2e;
  padding: 0.4rem 1.3rem;
  text-align: center;
  border: none;
  cursor: pointer;
  border-radius: 4px;
  margin: 10px;
  color: white;
}
.headline {
  color: white;
}
.project {
  background: #ff2e2e;
}
</style>
